import { render, staticRenderFns } from "./newlist.vue?vue&type=template&id=08d2cb63&scoped=true"
import script from "./newlist.vue?vue&type=script&lang=js"
export * from "./newlist.vue?vue&type=script&lang=js"
import style0 from "./newlist.vue?vue&type=style&index=0&id=08d2cb63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2cb63",
  null
  
)

export default component.exports